/**
 * AuthLayout del frontend-superadmin.
 *
 * Sprint 11 v2 S11-V2-11. Wrapper con Header negro + Outlet + Footer.
 */
import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';

export function AuthLayout() {
  return (
    <div className="min-h-screen bg-bg-page flex flex-col">
      <Header />
      <main className="flex-1 bg-bg-card">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
